import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PROMPTS_QUERY_KEY } from './useGetPrompts';

import PromptsService, {
  FilterPromptsDto,
  Prompt,
} from '@/services/PromptsService';

export function useRemovePrompt(filters: FilterPromptsDto) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (id: string) => {
      await PromptsService.removePrompt(id);
    },
    onMutate: async (removedId) => {
      await queryClient.cancelQueries({
        queryKey: GET_PROMPTS_QUERY_KEY(filters),
      });

      const previousPrompts = queryClient.getQueryData(
        GET_PROMPTS_QUERY_KEY(filters),
      );

      queryClient.setQueryData(GET_PROMPTS_QUERY_KEY(filters), (old: any) => {
        if (!old) return old;

        if (old.pages) {
          const newData = {
            ...old,
            pages: old.pages.map((page: any) => ({
              ...page,
              data: page.items.filter((prompt: Prompt) => {
                return prompt.id !== removedId;
              }),
            })),
          };
          return newData;
        }

        return old;
      });

      return { previousPrompts };
    },
    onError: (_, __, context) => {
      if (context?.previousPrompts) {
        queryClient.setQueryData(
          GET_PROMPTS_QUERY_KEY(filters),
          context.previousPrompts,
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: GET_PROMPTS_QUERY_KEY(filters),
      });
    },
  });

  return {
    removePrompt: mutateAsync,
    isRemoving: isPending,
  };
}
